import { cameras } from '../view/cameras';
import { update } from '../modes.js';
import { preload } from '../core/preload';
import { create } from './start.js';
import Phaser from 'phaser';

Phaser.GameObjects.GameObject.prototype.myIgnore = function (arg) {
    arg === 'top' ?
        cameras.top.ignore(this):
        game.cameras.main.ignore(this);

    return this;
};

const phaserConfig = {
    type: Phaser.CANVAS,
    audio: {
        noAudio: true
    },
    banner: {
        hidePhaser: true
    },
    scale: {
        mode: Phaser.Scale.RESIZE,
        parent: 'phaser-div',
        width: '100%',
        height: '100%',
        min: {
            width: 400,
            height: 400
        },
        max: {
            width: 1800,
            height: 1000
        }
    },
    dom: {
        createContainer: true
    },
    scene: { preload, create, update }
};

export const launchPhaser = () => {
    window.gameObject = new Phaser.Game(phaserConfig);
};
